import React from 'react'
import { Table } from 'antd'
import { useTranslation } from 'react-i18next'

export default function AuthenticatorAppsTable() {
  const { t } = useTranslation()
  const columns = [
    {
      title: t('AUTHENTICATOR_APP'),
      dataIndex: 'app',
      key: 'app'
    },
    { title: 'iPhone', dataIndex: 'iphone', key: 'iphone' },
    { title: 'Android', dataIndex: 'android', key: 'android' }
  ]

  const dataSource = [
    {
      app: t('GOOGLE_AUTHENTICATOR'),
      iphone: (
        <a
          href="https://apps.apple.com/us/app/google-authenticator/id388497605"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('APP_STORE')}
        </a>
      ),
      android: (
        <a
          href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('PLAY_STORE')}
        </a>
      ),
      key: 'google'
    },
    {
      app: t('LASTPASS_AUTHENTICATOR'),
      iphone: (
        <a
          href="https://apps.apple.com/us/app/lastpass-authenticator/id1079110004"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('APP_STORE')}
        </a>
      ),
      android: (
        <a
          href="https://play.google.com/store/apps/details?id=com.lastpass.authenticator&hl=en"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('PLAY_STORE')}
        </a>
      ),
      key: 'lastpass'
    },
    {
      app: t('MICROSOFT_AUTHENTICATOR'),
      iphone: (
        <a
          href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('APP_STORE')}
        </a>
      ),
      android: (
        <a
          href="https://play.google.com/store/apps/details?id=com.azure.authenticator&hl=en"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('PLAY_STORE')}
        </a>
      ),
      key: 'microsoft'
    }
  ]

  return (
    <>
      <Table columns={columns} dataSource={dataSource} pagination={false} />
      <div style={{ marginTop: 10 }}>{t('MFA_TABLE_SUMMARY')}</div>
    </>
  )
}
